var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kun_loading82_container"},[_c('div',{staticClass:"loader"},[_c('div',{staticClass:"panWrapper"},[_c('div',{staticClass:"pan"},[_c('div',{staticClass:"food"}),_c('div',{staticClass:"panBase"}),_c('div',{staticClass:"panHandle"})]),_c('div',{staticClass:"panShadow"})])])])
}]

export { render, staticRenderFns }